/**
 * @param {string} path
 * @returns {Boolean}
 */
export function emailBody(pregnancy, type, aeTreatments) {
  
  const body = {
    'Company': `
Dear all, 

please find attached the PREGNANCY report as detailed below.

Patient ID: ${pregnancy.patient_id}
Date pregnancy confirmed: ${pregnancy.date_pregnancy_confirmed}
Case type: ${pregnancy.case_type}
Case identification number: ${pregnancy.cin}

We remain at your disposal for any issue. 

Best regards, 
Pharmacovigilance Office`,
      
    'Medical Monitor': `
Dear medical monitor,

please find attached the PREGNANCY report as detailed below 

Patient ID: ${pregnancy.patient_id}
Date pregnancy confirmed: ${pregnancy.date_pregnancy_confirmed}
Case type: ${pregnancy.case_type}
Case identification number: ${pregnancy.cin}

We remain at your disposal for any issue. 

Best regards,
Pharmacovigilance Office

--
Only for SafetyDB registered users <a href="${window.location.href}" target="blank">click here</a>`,

  };
  return body[type];
}


export function emailSubject(pregnancy, type) {
  const subject = {
    'Company': `Protocol ${pregnancy.protocol.name}_{Protocol Company Code}_Pregnancy Patient ${pregnancy.patient_id}_${pregnancy.case_type}`,
    'Medical Monitor': `Protocol ${pregnancy.protocol.name}_Pregnancy Patient ${pregnancy.patient_id}_${pregnancy.case_type}`
  };
  return subject[type];
}
